<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
	@let ds = dataSource;
	@if(ds){
		<table mat-table [dataSource]="ds ?? []" matSort class="w-100">
			<ng-container matColumnDef="checked">
				<th mat-header-cell *matHeaderCellDef>Add</th>
				<td mat-cell *matCellDef="let value"> 
					<mat-checkbox [(ngModel)]="value.checked" [disabled]="value.nameTaken"></mat-checkbox>
				</td>
			</ng-container>

			<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>Field name</th>
			<td mat-cell *matCellDef="let value"> {{value.metadataInfo.name}} </td>
			</ng-container>
	
			<ng-container matColumnDef="description">
			<th mat-header-cell *matHeaderCellDef>Description</th>
			<td mat-cell *matCellDef="let value"> {{(getMetadataRuleDefinition(value.metadataInfo.ruleId) | async)?.description}} </td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let value; columns: displayedColumns;"></tr>
		</table>
	}
</mat-dialog-content>
<mat-dialog-actions>
	<div class="w-100 flex-row justify-end items-center mt-3 p-2">
		<a mat-button class="dialog-btn mr-5" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
		<a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
	</div>
</mat-dialog-actions>
